import type { ReactNode } from 'react';
import { Button } from '@fff-web/fff-ui-shared';

export interface WriteReviewButtonProps {
  onClick: () => void;
  children?: ReactNode;
}

const WriteReviewButton = ({ onClick, children }: WriteReviewButtonProps) => (
  <Button onClick={onClick} variation="black">
    {children || 'Write a Review'}
  </Button>
);

export default WriteReviewButton;
